<button
  [attr.aria-label]="ariaLabel || title"
  [disabled]="disabled"
  [ngClass]="buttonClasses"
  [type]="type"
  (click)="onClick($event)">
  <mat-icon class="share-icon">
    {{ icon }}
  </mat-icon>
  <span class="share-button-content">
    <span class="share-button-title">
      {{ title }}
    </span>
    <span
      *ngIf="subtitle"
      class="share-button-subtitle">
      {{ subtitle }}
    </span>
  </span>
</button>
